import { Component } from '@angular/core';
import { IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from 'ionic-angular';
import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import { GroupsAddPage } from "../groups-add/groups-add"
import {Subject} from "rxjs";

@IonicPage()
@Component({
  selector: 'page-groups',
  templateUrl: 'groups.html',
})
export class GroupsPage {

  ngUnsubscribe : Subject<any> = new Subject<any>();
  public groupList: Observable<any[]>;
  user: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      this.groupList = database.getGroups(user.clinic_id)
        .snapshotChanges()
        .takeUntil(this.ngUnsubscribe)
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });
      this.groupList.subscribe((groups) => {
        console.log(groups);
      });
    });
  }

  presentAddGroupModal() {
    let groupModal = this.modalCtrl.create(GroupsAddPage, {showBackdrop: true, enableBackdropDismiss: false});
    groupModal.present();
  }

  presentEditGroupModal(group)  {
    let groupModal = this.modalCtrl.create(GroupsAddPage, {'group_data': group} , {showBackdrop: true, enableBackdropDismiss: false});
    groupModal.present();
  }

  deleteGroup (group) {
    let confirm = this.alertCtrl.create({
      title: `Are you sure you'd like to delete ${group.group_name}?\nAll patients in this group will be removed from it.`,
      buttons: [
        {
          text: "Yes",
          handler: () => {
            this.database.deleteGroup(this.user.clinic_id, group.id, this.ngUnsubscribe).then(() => {
              this.toastCtrl.create({
                message: `${group.group_name} has been deleted`,
                duration: 3000
              }).present()
            })
          }
        },
        {
          text: "No",
          handler: () => {}
        }
      ]
    });

    confirm.present();
  }

  ngOnDestroy() {
    console.log('Leave groups page and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/groups/groups.ts